import { useApolloClient } from '@apollo/client'
import { Formik, Form } from 'formik'
import { Error, InputField } from '@myap/ui-library'
import { Modal, PrimaryButton } from '@cb/apricot-react'
import useStudentJoinCourseDetailsQuery from '../../hooks/useStudentJoinCourseDetailsQuery'
import { setJoinCourseDetails } from '../../../../appsync/actions/student'
import * as c from './constants'

import styles from '../joincourse.module.scss'

function FooterActions({
  isValid,
  values: { [c.SPOKEN_FIELD]: spoken },
  enrollments,
  changeStep,
}) {
  const client = useApolloClient()

  // Get join course details
  const { data: joinCourseData } = useStudentJoinCourseDetailsQuery({})

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <PrimaryButton
        disabled={!isValid}
        onClick={async () => {
          setJoinCourseDetails(client, {
            ...joinCourseData,
            [c.SPOKEN_FIELD]: spoken === 'true',
          })
          changeStep(!enrollments?.length ? c.INFORMATION : c.SAVE)
        }}
      >
        Continue
      </PrimaryButton>
    </div>
  )
}

function SurveyStep({ changeStep, enrollments }) {
  return (
    <Formik
      initialValues={{ [c.SPOKEN_FIELD]: '' }}
      enableReinitialize={true}
      validateOnMount={true}
    >
      {({ isValid, values, error }) => (
        <Modal
          title="Language Question"
          footer={
            <FooterActions
              isValid={isValid}
              values={values}
              enrollments={enrollments}
              changeStep={changeStep}
            />
          }
          open={true}
          openAnimation={false}
          closeAnimation={false}
          shadowRoot
          modalNode
        >
          <div className={styles.survey}>
            <p>
              Since you have indicated you are enrolling in an AP language course, please answer the
              following question. Your response will not affect the score of your exam.
            </p>
            <div className="cb-spacerv-16" />
            <Form>
              <fieldset>
                <legend className="cb-required">
                  Do you regularly speak or hear the language at home?
                </legend>
                <div className="cb-spacerv-8" />
                <InputField
                  label="Yes"
                  value="true"
                  name={c.SPOKEN_FIELD}
                  type="radio"
                  required={true}
                  hideRequiredIndicator={true}
                />
                <div className="cb-spacerv-8" />
                <InputField
                  label="No"
                  value="false"
                  name={c.SPOKEN_FIELD}
                  type="radio"
                  required={true}
                  hideRequiredIndicator={true}
                />
              </fieldset>
              {error ? <Error message={error} /> : null}
            </Form>
          </div>
        </Modal>
      )}
    </Formik>
  )
}

export default SurveyStep
